import axios, {AxiosResponse} from 'axios'
import {PrivacyPolicy} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const PRIVACY_POLICIES_URL = `${API_URL}/api/privacy-policies`

export function getActivePrivacyPolicy(): Promise<PrivacyPolicy> {
  return axios.get(`${PRIVACY_POLICIES_URL}/active`).then((response) => response.data.data)
}

export function acceptPrivacyPolicy(): Promise<AxiosResponse<any, any>> {
  return axios.post(`${PRIVACY_POLICIES_URL}/accept`)
}
